import { Observable } from 'rxjs';

export class TimestampObservableCache<T> {
  /**
   * Default value for expiration.
   */
  public static readonly DEFAULT_EXPIRATION_IN_SECONDS: number = 10;

  /**
   * Time when cache expire.
   */
  protected expiration: Date = null;

  /**
   * Create observable cache, which expire in specific time.
   *
   * @param observable
   * @param expirationInSeconds   Expiration in seconds, if null default value is used.
   */
  public constructor(public observable: Observable<T>, public expirationInSeconds: number | null = null) {
    if (expirationInSeconds === null) {
      this.expirationInSeconds = TimestampObservableCache.DEFAULT_EXPIRATION_IN_SECONDS;
    }
    this.expiration = new Date();
    this.expiration.setSeconds(this.expiration.getSeconds() + this.expirationInSeconds);
  }

  /**
   * Return if cache is expired.
   */
  public isExpired(): boolean {
    const now = new Date();
    return now > this.expiration;
  }
}
